import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminImport from "@/pages/admin/AdminImport";

export const Route = createFileRoute("/admin/import")({
  component: () => (
    <ProtectedRoute>
      <AdminImport />
    </ProtectedRoute>
  ),
});
